export default __webpack_public_path__ + "static/media/coldchain-trash.c10b1b57.svg";